import Vue from 'vue';

export async function read(messageId){
    return (await Vue.http.post(`http://localhost:5066/api/messages/${messageId}/read`)).data;
}



// WEBPACK FOOTER //
// ./skins/xkiosk/services/message.service.js